var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.687 0.00559939C6.31606 0.158965 2.6849 3.56909 2.26541 7.92196C2.1797 8.79254 2.22932 9.63605 2.38268 10.4435C2.38268 10.4435 2.39622 10.5382 2.44132 10.7186C2.57665 11.3231 2.77963 11.9095 3.03223 12.4598C3.91183 14.5437 5.94618 18.0305 10.5111 21.8241C10.7907 22.0586 11.2012 22.0586 11.4854 21.8241C16.0503 18.0351 18.0846 14.5483 18.9687 12.4553C19.2258 11.905 19.4243 11.3231 19.5596 10.7141C19.6002 10.5382 19.6183 10.439 19.6183 10.439C19.722 9.89767 19.7761 9.34285 19.7761 8.77449C19.7761 3.82169 15.6759 -0.17032 10.687 0.00559939ZM10.9982 13.1409C8.6436 13.1409 6.73556 11.2329 6.73556 8.87824C6.73556 6.52363 8.6436 4.61558 10.9982 4.61558C13.3528 4.61558 15.2609 6.52363 15.2609 8.87824C15.2609 11.2329 13.3528 13.1409 10.9982 13.1409Z",
    fill: "#28A137"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.93dfdefc522d92741590b72dabf61dfc.svg";
export { ForwardRef as ReactComponent };